<template>
    <div class="search flex-all pl-3">
        <div class="relative">
            <div class="write d-flex align-items-center justify-content-start">
                <i class="ico-search larger pointer dark" ></i>
                <input type="text" class="query dark fs-small" v-model="query" @keyup.enter="searchTicket" placeholder="Search ticket number">
            </div>

        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        data: function() {
            return {
                query: '',
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedReservation',
                'getReservationsById'
            ]),
            reservation: function() {
                return this.getSelectedReservation;
            }
        },
        methods: {
            ...mapActions([
                'openModal',
                'openReservationById'
            ]),
            searchTicket: function(e) {
                this.openReservationById(this.query)
            },
            triggerReservation(event, id) {
                // Triggers the reservation modal by searching for a specific reservation

                var found = getReservationsById(id);

                if (found) {
                    this.getSelectedReservation = found;
                    this.openModal('ReservationView');
                }
            }
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';

    .bar {
        .search {
            .write {
                input {
                    border: 0;
                    width: 100%;
                    line-height: 1em;
                    margin: 0;
                }
            }

            .results {
                position: absolute;
                top: 80%;
                left: 0;
                z-index: 5;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Search.vue?59aaa389